<template>
	<b-overlay
		id="overlay-background"
		spinner-variant="primary"
		:show="isLoading"
		variant="transparent"
		opacity="1.00"
		blur="0.5em"
		rounded="sm"
		class="w-100"
	>
		<b-row v-if="orderDetail">
			<b-col cols="12">
				<b-card class="order-action-card">
					<div class="d-flex flex-wrap align-items-center justify-content-between">
						<div>
							<div class="text-muted small">Status Order</div>
							<div class="font-weight-bolder">{{ orderDetail.status || '-' }}</div>
						</div>
						<b-button
							v-if="orderDetail.status === 'UNCONFIRM'"
							variant="primary"
							:disabled="isProcessing"
							@click="processModal = true"
						>
							<b-spinner v-if="isProcessing" small class="mr-50" />
							Konfirmasi Pesanan
						</b-button>
					</div>
				</b-card>
			</b-col>
			<b-col cols="12" md="6">
				<b-card>
					<b-row>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">No. Invoice</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span class="font-weight-bolder">{{
								orderDetail.transaction.no_invoice
							}}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Pembayaran</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<b-form-input
								v-model="orderDetail.transaction.status"
								disabled
								placeholder="Payment Status"
							/>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Tgl. Pembayaran</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<b-form-input
								v-model="orderDetail.transaction.payment_date"
								placeholder="Payment Status"
								disabled
							/>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Delivery</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<b-form-input
								v-model="orderDetail.shipment.shipment_status"
								placeholder="Payment Status"
								disabled
							/>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Tgl. Delivery</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<b-form-input
								v-model="orderDetail.shipment.payment_date"
								placeholder="Payment Status"
								disabled
							/>
						</b-col>
					</b-row>
				</b-card>
			</b-col>
			<b-col cols="12" md="6">
				<b-card>
					<b-row>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Nama Customer</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<router-link
								:to="{ name: 'apps-users-view', params: { id: orderDetail.user_id } }"
							>
								<span>{{ orderDetail.user.nama_customer }}</span>
							</router-link>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Email</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.user.email }}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">No. Hp</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.user.no_hp }}</span>
						</b-col>
					</b-row>
				</b-card>
			</b-col>
			<b-col cols="12">
				<b-card>
					<b-card-title> Produk </b-card-title>
					<b-table responsive :items="orderDetail.items" :fields="itemsColumn">
						<template #cell(no)="data">
							<span>{{ data.index + 1 }}.</span>
						</template>
						<template #cell(kd_produk)="data">
							<div class="d-flex flex-column">
								<span class="font-weight-bolder">{{ data.item.name }}</span>
								<span style="font-size: smaller">{{ data.item.kd_produk }}</span>
							</div>
						</template>
						<template #cell(total)="data">
							{{ formatCurrency(calcTotal(data.item)) }}
						</template>
					</b-table>
				</b-card>
			</b-col>
			<b-col cols="6">
				<b-card>
					<b-card-title> Voucher/Kupon </b-card-title>
					<b-row v-if="orderDetail.voucher_usage !== null">
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Nomor Voucher</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.voucher_usage.code }}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Jenis</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ typeVoucher(orderDetail.voucher_usage.type) }}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">No. Hp</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.user.no_hp }}</span>
						</b-col>
					</b-row>
					<div v-else class="w-100 d-flex justify-content-center">
						Tidak Ada Voucher
					</div>
				</b-card>
			</b-col>
			<b-col cols="6">
				<b-card>
					<b-card-title> Pembayaran </b-card-title>
					<b-row>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Metode Bayar</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ title(orderDetail.transaction.type, '_') }}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Status</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.transaction.status }}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Tanggal Pembayaran</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{
								orderDetail.transaction.payment_date === null
									? '-'
									: orderDetail.transaction.payment_date
							}}</span>
						</b-col>
					</b-row>
				</b-card>
			</b-col>
			<b-col cols="6">
				<b-card>
					<b-card-title> Alamat Pengiriman </b-card-title>
					<b-row>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Nama Penerima</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.receiver.name }}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">No. HP/Telp</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.receiver.phone_number }}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Label</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.receiver.label_address }}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Alamat</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>
								{{ orderDetail.receiver.address }}, {{ orderDetail.receiver.district }},
								{{ orderDetail.receiver.city }}, {{ orderDetail.receiver.provinsi }},
								{{ orderDetail.receiver.postal_code }}</span
							>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Catatan</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ orderDetail.receiver.note }}</span>
						</b-col>
					</b-row>
				</b-card>
			</b-col>
			<b-col cols="6">
				<b-card>
					<b-card-title> Status Pengiriman </b-card-title>
				</b-card>
			</b-col>
			<b-col cols="6" />
			<b-col cols="6">
				<b-card>
					<b-card-title> Order Total </b-card-title>
					<b-row>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Sub Total</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ formatCurrency(subTotal(orderDetail.items)) }}</span>
						</b-col>
						<b-col
							v-if="
								orderDetail.voucher_usage !== null &&
								(orderDetail.voucher_usage.type === 'fixed' ||
									orderDetail.voucher_usage.type === 'percentage')
							"
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Discount</span>
						</b-col>
						<b-col
							v-if="
								orderDetail.voucher_usage !== null &&
								(orderDetail.voucher_usage.type === 'fixed' ||
									orderDetail.voucher_usage.type === 'percentage')
							"
							cols="8"
							class="mb-1"
						>
							<span>{{
								orderDetail.voucher_usage.type === 'fixed'
									? formatCurrency(orderDetail.voucher_usage.value)
									: `${orderDetail.voucher_usage.value}%`
							}}</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Biaya Pengiriman/Kurir</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ formatCurrency(orderDetail.shipment.shipment_price) }}</span>
						</b-col>
						<b-col
							v-if="
								orderDetail.voucher_usage !== null &&
								orderDetail.voucher_usage.type === 'shipping'
							"
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Gratis Ongkir</span>
						</b-col>
						<b-col
							v-if="
								orderDetail.voucher_usage !== null &&
								orderDetail.voucher_usage.type === 'shipping'
							"
							cols="8"
							class="mb-1"
						>
							<span>({{ formatCurrency(orderDetail.voucher_usage.value) }})</span>
						</b-col>
						<b-col
							cols="4"
							class="text-right d-flex align-items-center justify-content-end mb-1"
						>
							<span class="font-weight-bolder">Grand Total</span>
						</b-col>
						<b-col cols="8" class="mb-1">
							<span>{{ formatCurrency(total(orderDetail)) }}</span>
						</b-col>
					</b-row>
				</b-card>
			</b-col>
		</b-row>
		<b-card v-else-if="!isLoading">
			<div class="text-center text-muted py-3">
				Data order tidak ditemukan atau gagal dimuat.
			</div>
		</b-card>
		<b-modal
			v-model="processModal"
			centered
			title="Konfirmasi Pesanan"
			:ok-disabled="isProcessing"
			:cancel-disabled="isProcessing"
			ok-title="Konfirmasi"
			cancel-title="Batal"
			@ok="confirmOrder"
		>
			Pesanan akan diproses setelah dikonfirmasi. Lanjutkan?
			<template #modal-ok>
				<b-spinner v-if="isProcessing" small class="mr-50" />
				Konfirmasi
			</template>
		</b-modal>
	</b-overlay>
</template>
<script>
import {
	BCard,
	BRow,
	BCol,
	BFormInput,
	BTable,
	BCardTitle,
	BOverlay,
	BButton,
	BModal,
	BSpinner,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { formatCurrency, title } from '@/@core/utils/filter'
import { typeVoucherOptions } from '@core/utils/constant'
import useOrder from './useOrder'

export default {
	components: {
		BCard,
		BRow,
		BCol,
		BFormInput,
		BTable,
		BCardTitle,
		BOverlay,
		BButton,
		BModal,
		BSpinner,
	},
	setup(props, context) {
		const {
			retrieveOrder,
			orderDetail,
			calcTotal,
			subTotal,
			total,
			isLoading,
		} = useOrder()
		const itemsColumn = ref([
			{
				label: 'No.',
				key: 'no',
				thClass: 'number_column_class',
			},
			{
				label: 'Kode Produk',
				key: 'kd_produk',
			},
			{
				label: '@Harga',
				key: 'price',
				formatter: val => formatCurrency(val),
			},
			{
				label: 'Kuantiti',
				key: 'quantity',
			},
			{
				label: 'Diskon',
				key: 'discount',
				formatter: val => {
					if (val !== 0 || val !== null) {
						return `${val}%`
					}
					return '0%'
				},
			},
			{
				label: 'Total',
				key: 'total',
			},
		])

		const processModal = ref(false)
		const isProcessing = ref(false)

		onMounted(() => {
			retrieveOrder(context.root.$route.params.id)
		})

		const confirmOrder = event => {
			event.preventDefault()
			isProcessing.value = true

			context.root.$http
				.post('/api/auth/order/process', {
					order_id: context.root.$route.params.id,
				})
				.then(() => {
					processModal.value = false
					retrieveOrder(context.root.$route.params.id)
				})
				.catch(error => {
					const message = error.response?.data?.message || 'Pesanan gagal dikonfirmasi.'
					context.root.$bvToast.toast(message, {
						title: 'Konfirmasi Pesanan Gagal',
						variant: 'danger',
						solid: true,
					})
				})
				.finally(() => {
					isProcessing.value = false
				})
		}

		const typeVoucher = typeCode => {
			const option = typeVoucherOptions.find(x => x.value === typeCode)
			return option ? option.text : '-'
		}
		return {
			orderDetail,
			itemsColumn,
			formatCurrency,
			calcTotal,
			typeVoucher,
			title,
			subTotal,
			total,
			isLoading,
			processModal,
			isProcessing,
			confirmOrder,
		}
	},
}
</script>
<style lang="scss">
.number_column_class {
	width: 50px;
}

.order-action-card .card-body {
	padding: 1rem 1.25rem;
}
</style>
